import { ServiceBannerCarousel } from './components/banner';
import ServiceTabs from '../../components/serviceTabs';
import MA_ICON from '../../assets/myServiceIcons/manageAccount.jpeg';
import RR_ICON from '../../assets/myServiceIcons/raiseRequest.jpeg';
import TS_ICON from '../../assets/myServiceIcons/trackStatus.jpeg';
import CU_ICON from '../../assets/myServiceIcons/contactUs.jpeg';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { AccountInformation } from '../../types/manageAccount.type';
import { RootState } from '../../store/store';
import ManageAccountService from '../../services/manageAccount.service';
import { logout } from '../../store/Slices/authSlice';
import { useNavigate } from 'react-router-dom';
import hand from '../../assets/images/handIcon.png';
import { LogoutOutlined } from '@mui/icons-material';

export default function Home() {
  const { userId, token } = useSelector((state: RootState) => state.auth);
  const [user, setUser] = useState<AccountInformation | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (userId && token) {
      ManageAccountService.getAccountInfoAsync(userId, token).then((data) => {
        if (!data) return dispatch(logout());
        setUser(data);
      });
    } else {
      navigate('login', {
        replace: true,
      });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box className="container mx-auto flex flex-col min-h-screen gap-2" bgcolor={'#eee'}>
      <Stack gap={1} className="px-3" pt={2}>
        {user && (
          <Stack direction="row" alignItems="center" gap={2} sx={{ justifyContent: 'space-between' }}>
            <Stack flexDirection={'row'} display={'flex'} alignItems={'center'} gap={0.5}>
              <Typography fontSize={18} variant="h5">
                Welcome, {user?.first_name ?? ''}
              </Typography>
              <img
                className="w-5 h-5"
                style={{
                  animation: `hands 1s infinite ease-in-out`,
                }}
                src={hand}
                alt="hand"
              />
            </Stack>
            <Button
              onClick={() => {
                dispatch(logout());
              }}
              className="flex gap-2"
              color="secondary"
            >
              <LogoutOutlined />
            </Button>
          </Stack>
        )}
        <ServiceBannerCarousel />
      </Stack>
      <Box className="flex flex-col items-center">
        <Box className="flex gap-3 justify-center">
          <ServiceTabs
            title="My Account"
            description="Personal Information"
            image_blob={MA_ICON}
            path="manage-account"
          />
          <ServiceTabs
            title="Raise Request"
            description="Installation / Complaints"
            image_blob={RR_ICON}
            path="/raise-request"
          />
        </Box>
        <Box className="flex gap-3 justify-center">
          <ServiceTabs
            title="Track / Escalate"
            description="Track / Escalate requests"
            image_blob={TS_ICON}
            path="/track-status"
          />
          <ServiceTabs
            title="Contact us"
            description="We are here to help"
            image_blob={CU_ICON}
            path="contact-us"
          />
        </Box>
      </Box>
      <div className="w-[92vw] mx-auto rounded-lg overflow-hidden px-3 bg-white">
        <img
          alt="banner"
          className="w-full h-full object-contain object-center rounded-lg"
          src={
            'https://www.ifbappliances.com/media/banners/home/Desktop_Banner-1280x570-No_logo.png'
          }
        />
      </div>
    </Box>
  );
}
